:host {
    --wf-newsletter-subscription-background-color: var(--wf-traubenrot-70);
    --wf-footer-awards-background-color: var(--wf-gray-01);
    --wf-footer-disclaimer-background-color: var(--wf-gray-01);
    --wf-footer-section-divider-color: var(--wf-gray-02);
    --wf-footer-section-title-color: var(--wf-black);
    box-sizing: border-box;
    font-weight: normal;
}

section {
    display: grid;
    grid-template-columns: 1fr;
    align-items: self-start;
}

section,
wf-footer-disclaimer,
wf-shop-awards {
    padding-left: 16px;
    padding-right: 16px;
}

@media screen and (min-width: 768px) {
    section {
        gap: 16px;
        grid-template-columns: repeat(2, 1fr);

        &:not(:last-child) {
            border-bottom: 1px solid var(--wf-footer-section-divider-color);
        }
    }
}

@media screen and (min-width: 992px) {
    section {
        gap: 32px;
        grid-template-columns: repeat(4, 1fr);
    }

    section,
    wf-footer-disclaimer,
    wf-shop-awards {
        padding-left: 80px;
        padding-right: 80px;
    }
}
